import React, { useEffect } from 'react';
import * as S from './Modal.styled';

interface ModalProps {
  isOpen: boolean;
  maxWidth?: number;
  onClose: () => void;
  isScrollLocked?: boolean;
  dataTestId?: string;
  children: React.ReactNode;
}

export const Modal = ({
  isOpen,
  onClose,
  children,
  maxWidth = 460,
  dataTestId,
  isScrollLocked = false,
}: ModalProps) => {
  useEffect(() => {
    if (isScrollLocked) {
      document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    }
  }, [isOpen, isScrollLocked]);

  if (!isOpen) return null;

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onClose();
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <S.ModalWrapper data-testid={dataTestId}>
      <S.Backdrop
        onClick={handleClose}
        $isOpen={isOpen}
        data-testid="modal-backdrop"
      />
      <S.ModalContent
        $isOpen={isOpen}
        $maxWidth={maxWidth}
        onClick={handleContentClick}
        data-testid="modal-content"
      >
        {children}
      </S.ModalContent>
    </S.ModalWrapper>
  );
};
